import React from 'react';

import { BodyProps } from './types';
import { Component, ImageGrey, ImageBlue, ImageOrange } from './styles';

export const Body = React.memo<BodyProps>(({ grey, blue, orange }) => {
  return (
    <Component>
      <ImageGrey src={grey} alt="" />
      <ImageBlue src={blue} alt="" />
      <ImageOrange src={orange} alt="" />
    </Component>
  );
});
